import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import "../styles/main.css";
import TrytheDemo from "./express-embed-sdk/trydemo.md";
import EditingTool from "./express-embed-sdk/editing-tools.md";
import LearnMore from "./express-embed-sdk/learn-more.md";
import EditImageTable from "./express-embed-sdk/edit-photo.md";
import EditVideoTable from "./express-embed-sdk/edit-video.md";
import bgImg from "./images/Summary_BgImage.jpg";
import DesignForDeveloper from "./express-embed-sdk/design-for-develop.md";
import MobileEditPhoto from "./express-embed-sdk/mobile-edit-photo.md";
import MobileEditVideo from "./express-embed-sdk/mobile-edit-video.md";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const TitleBlock = makeShortcode("TitleBlock");
const WrapperComponent = makeShortcode("WrapperComponent");
const TextBlock = makeShortcode("TextBlock");
const FormWrapperComponent = makeShortcode("FormWrapperComponent");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const MiniResourceCard = makeShortcode("MiniResourceCard");
const TeaserBlock = makeShortcode("TeaserBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading, text, buttons, assetsImg" customLayout variant="halfwidth" className="express-sdk-hero" mdxType="Hero" />
    <h2 {...{
      "id": "design-create-personalize---right-inside-your-web-app"
    }}>{`Design, create, personalize - right inside your web app.`}</h2>
    <p>{`Empower your users to create with `}<a parentName="p" {...{
        "href": "https://adobe.com/express"
      }}>{`Adobe Express`}</a>{` editing and AI capabilities for a more intuitive design experience.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://demo.expressembed.com/"
        }}>{`Try the demo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/embed-sdk/docs/guides"
        }}>{`Get started`}</a></li>
    </ul>
    <p>{`homeExpressLandingPage`}</p>
    <TitleBlock slots="heading" theme="light" className="users-work" mdxType="TitleBlock" />
    <h3 {...{
      "id": "give-your-users-more-to-work-with-in-no-time"
    }}>{`Give your users more to work with, in no time.`}</h3>
    <WrapperComponent slots="content" repeat="1" theme="light" className="editingDescription" mdxType="WrapperComponent" />
    <EditingTool mdxType="EditingTool" />
    <WrapperComponent slots="content" repeat="1" theme="light" className="learnmoreBtn" mdxType="WrapperComponent" />
    <LearnMore mdxType="LearnMore" />
    <TitleBlock slots="heading" theme="light" className="chooseEdit" mdxType="TitleBlock" />
    <h3 {...{
      "id": "choose-the-editing-experience-that-works-for-you"
    }}>{`Choose the editing experience that works for you.`}</h3>
    <TextBlock slots="heading,text,image,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="explore unleash-power createTemplate" position="left" mdxType="TextBlock" />
    <h3 {...{
      "id": "a-focus-mode-for-content-creation"
    }}>{`A focus mode for content creation`}</h3>
    <p>{`Modules are task-oriented tools focused on what creators need, when they need it. Choose from Generate Image or Edit Image, with Generate Template module on the way.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "512px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "110.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/6a99701e748d915a2582916cf0a8a778/5530d/ValueProp_TexttoImage.webp 320w", "/express/embed-sdk/static/6a99701e748d915a2582916cf0a8a778/2bf0f/ValueProp_TexttoImage.webp 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/6a99701e748d915a2582916cf0a8a778/dd4a7/ValueProp_TexttoImage.png 320w", "/express/embed-sdk/static/6a99701e748d915a2582916cf0a8a778/06341/ValueProp_TexttoImage.png 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/embed-sdk/static/6a99701e748d915a2582916cf0a8a778/06341/ValueProp_TexttoImage.png",
            "alt": "Adobe Express functionality",
            "title": "Adobe Express functionality",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/embed-sdk/docs/guides/modules/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="heading,text,image,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="qaImage" position="right" mdxType="TextBlock" />
    <h3 {...{
      "id": "get-instant-results-with-one-click-editing-tools"
    }}>{`Get instant results with one-click editing tools`}</h3>
    <p>{`Quick actions let you embed image and video editing capabilities like Remove Background, Crop Image, and Caption Video – all powered by Adobe Express.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.3125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/5530d/Embed_QuickActions.webp 320w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/0c8fb/Embed_QuickActions.webp 640w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/94b1e/Embed_QuickActions.webp 1280w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/0b34d/Embed_QuickActions.webp 1920w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/d5269/Embed_QuickActions.webp 2560w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/f0312/Embed_QuickActions.webp 5000w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/dd4a7/Embed_QuickActions.png 320w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/0f09e/Embed_QuickActions.png 640w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/bbbf7/Embed_QuickActions.png 1280w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/ac7a9/Embed_QuickActions.png 1920w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/c7a69/Embed_QuickActions.png 2560w", "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/cd15d/Embed_QuickActions.png 5000w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/embed-sdk/static/b145ff91ee3ef5829793f8ac09ab9a36/bbbf7/Embed_QuickActions.png",
            "alt": "Adobe Express functionality",
            "title": "Adobe Express functionality",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/embed-sdk/docs/guides/quick_actions/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TextBlock slots="heading,text,image,buttons" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' variantStyleFill="outline" homeZigZag className="explore unleash-power createTemplate" position="left" mdxType="TextBlock" />
    <h3 {...{
      "id": "bring-the-full-set-of-adobe-express-capabilities-to-your-users"
    }}>{`Bring the full set of Adobe Express capabilities to your users`}</h3>
    <p>{`The full Adobe Express editor lets users take advantage of Adobe’s professionally designed templates, stock images, fonts, text effects and add-ons.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "512px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "110.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/a5e47225298047c5fd5400d764a9fd4c/5530d/ValueProp_AllInOneEditor.webp 320w", "/express/embed-sdk/static/a5e47225298047c5fd5400d764a9fd4c/2bf0f/ValueProp_AllInOneEditor.webp 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/a5e47225298047c5fd5400d764a9fd4c/dd4a7/ValueProp_AllInOneEditor.png 320w", "/express/embed-sdk/static/a5e47225298047c5fd5400d764a9fd4c/06341/ValueProp_AllInOneEditor.png 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/embed-sdk/static/a5e47225298047c5fd5400d764a9fd4c/06341/ValueProp_AllInOneEditor.png",
            "alt": "Adobe Express functionality",
            "title": "Adobe Express functionality",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/embed-sdk/docs/guides/full_editor/"
        }}>{`Learn more`}</a></li>
    </ul>
    <TitleBlock slots="heading" theme="light" className="users-work" mdxType="TitleBlock" />
    <h3 {...{
      "id": "quick-actions"
    }}>{`Quick actions`}</h3>
    <FormWrapperComponent slots="content" repeat="2" theme="light" className="editTable" mdxType="FormWrapperComponent" />
    <EditImageTable mdxType="EditImageTable" />
    <EditVideoTable mdxType="EditVideoTable" />
    <WrapperComponent slots="content" repeat="1" theme="light" className="mobileEdit" mdxType="WrapperComponent" />
    <MobileEditPhoto mdxType="MobileEditPhoto" />
    <WrapperComponent slots="content" repeat="1" theme="light" className="mobileEdit" mdxType="WrapperComponent" />
    <MobileEditVideo mdxType="MobileEditVideo" />
 
    <WrapperComponent slots="content" repeat="1" theme="lightest" className="code-block" mdxType="WrapperComponent" />
    <DesignForDeveloper mdxType="DesignForDeveloper" />
    <TitleBlock slots="heading" theme="lightest" className="users-work faq" mdxType="TitleBlock" />
    <h3 {...{
      "id": "frequently-asked-questions"
    }}>{`Frequently Asked Questions`}</h3>
    <WrapperComponent slots="content" repeat="1" theme="lightest" className="accordion" mdxType="WrapperComponent" />
    <Accordion mdxType="Accordion">
      <AccordionItem header="What is the Adobe Express Embed SDK?" isChevronIcon position="right" iconColor="#1473E6" mdxType="AccordionItem">
        <p>{`The Adobe Express Embed SDK is a customizable JavaScript library that lets partners integrate Adobe Express content editing and AI tools inside of their web app.`}</p>
      </AccordionItem>
      <AccordionItem header="How much does it cost to use the Embed SDK?" isChevronIcon position="right" iconColor="#1473E6" mdxType="AccordionItem">
        <p>{`For developers, there is no cost to use the Embed SDK. For users, access to Adobe Express features are based on the user’s entitlements.`}</p>
      </AccordionItem>
      <AccordionItem header="How much time does it take to integrate the Embed SDK?" isChevronIcon position="right" iconColor="#1473E6" mdxType="AccordionItem">
        <p>{`Development time varies, but we have seen small teams finish integrations in a week.`}</p>
      </AccordionItem>
    </Accordion>
    <TitleBlock slots="heading" theme="lightest" className="users-work" mdxType="TitleBlock" />
    <h3 {...{
      "id": "weve-got-your-resources-covered"
    }}>{`We've got your resources covered.`}</h3>
    <MiniResourceCard slots="image,heading,link" repeat="3" theme="lightest" inRow="3" className="mini-card support-tools" mdxType="MiniResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "204px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/87c3a6cc5bb28225141962937cd8d19c/9ff1e/Embed-forums.webp 204w"],
            "sizes": "(max-width: 204px) 100vw, 204px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/87c3a6cc5bb28225141962937cd8d19c/29fac/Embed-forums.png 204w"],
            "sizes": "(max-width: 204px) 100vw, 204px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/embed-sdk/static/87c3a6cc5bb28225141962937cd8d19c/29fac/Embed-forums.png",
            "alt": "Community forum",
            "title": "Community forum",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "community-forum"
    }}>{`Community forum`}</h3>
    <p><a parentName="p" {...{
        "href": "https://community.adobe.com/t5/adobe-express-embed-sdk/ct-p/ct-express-embed-sdk?page=1&sort=latest_replies&lang=all&tabid=all"
      }}>{`Forums link`}</a></p>
    <p><img parentName="p" {...{
        "src": "/express/embed-sdk/assets/5193b6f5aa5a16fca1060d0734f7fa5d/Blog.svg",
        "alt": "Partner with us"
      }}></img></p>
    <h3 {...{
      "id": "faq"
    }}>{`FAQ`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/express/embed-sdk/docs/guides/troubleshooting/faq/"
      }}>{`FAQ`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "102px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/5d5693eb84eff96cc8586cb11c2024df/25849/code-samples.webp 102w"],
            "sizes": "(max-width: 102px) 100vw, 102px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/embed-sdk/static/5d5693eb84eff96cc8586cb11c2024df/712f4/code-samples.png 102w"],
            "sizes": "(max-width: 102px) 100vw, 102px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/embed-sdk/static/5d5693eb84eff96cc8586cb11c2024df/712f4/code-samples.png",
            "alt": "Code samples",
            "title": "Code samples",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "code-samples"
    }}>{`Code samples`}</h3>
    <p><a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/cc-everywhere/tree/main/v4-sample/sample.md"
      }}>{`Github repo with Embed SDK sample`}</a></p>
    <TeaserBlock slots="heading,text,buttons" textColor="white" bgURL={bgImg} className="viewAddOn" variant="fullwidth" mdxType="TeaserBlock" />
    <p className="teaserBlockCustomHeading">Let's do this.</p>
    <p>{`View our developer quickstart guide to start embedding Adobe Express capabilities into your web application, or try the demo.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/express/embed-sdk/docs/guides/"
        }}>{`View quickstart guide`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://demo.expressembed.com"
        }}>{`Try the demo`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      